<div class="mt-block">
  <div :class="$style.pageMargin" v-if="appSpinner">
    <animation-processing :class="$style.pageSpinner"></animation-processing>
    <span class="mt-serif mt-serif--size5"> {{$t('pages.foundry_application_preview.loading')}} </span>
  </div>
  <div v-else class="mt-wrapper">
    <div class="mb-25">
      <h1 class="mt-h1-fda">{{$t('pages.foundry_application_preview.heading')}}</h1>
    </div>
    <rejection-history :rejectionHistory="rejectionHistory" :id="$vId(this)"></rejection-history>
    <fou-container :id="$vId(this, 'review-application')" cols="12" background>
      <template #content>
        <div>
          <!-- Distribution Agreement -->
          <div class="mb-25">
            <h3
              class="mt-h3"
              :class="[$style.newFoundrySection, $style.setReviewContainerLeft, $style.agreementSection]"
            >
              {{$t('pages.foundry_application_preview.agreement')}}
            </h3>
            <div :class="[$style.setReviewContainerLeft]">
              <div :class="$style.customRow">
                <div :class="$style.divWidth1">
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.first_name')}}:
                  </span>
                  <span> {{firstName}} </span>
                </div>
                <div>
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.add1')}}:
                  </span>
                  <span> {{address1}} </span>
                </div>
              </div>
              <div :class="$style.customRow">
                <div :class="$style.divWidth1">
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.last_name')}}:
                  </span>
                  <span> {{lastName}} </span>
                </div>
                <div>
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.add2')}}:
                  </span>
                  <span> {{address2}} </span>
                </div>
              </div>
              <div :class="$style.customRow">
                <div :class="$style.divWidth1">
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.email')}}:
                  </span>
                  <span> {{email}} </span>
                </div>
                <div>
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.city')}}:
                  </span>
                  <span> {{city}} </span>
                </div>
              </div>
              <div :class="$style.customRow">
                <div :class="$style.divWidth1">
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.telephone')}}:
                  </span>
                  <span> {{phone}} </span>
                </div>
                <div>
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.state_region')}}:
                  </span>
                  <span> {{stateName}} </span>
                </div>
              </div>
              <div :class="$style.customRow">
                <div :class="$style.divWidth1">
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.signed')}}:
                  </span>
                  <span> {{signed}} </span>
                </div>
                <div>
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.postal_code')}}:
                  </span>
                  <span> {{zipCode}} </span>
                </div>
              </div>
              <div :class="$style.customRow">
                <div :class="$style.divWidth1">
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.title')}}:
                  </span>
                  <span> {{title}} </span>
                </div>
                <div>
                  <span class="mt-serif--bold mt-serif--bold--size4">
                    {{$t('components.navigation.sign_up.step_4.country')}}:
                  </span>
                  <span> {{countryName}} </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Foundry Information -->
          <div class="mb-25">
            <h3 class="mt-h3" :class="[$style.newFoundrySection, $style.setReviewContainerLeft]">
              {{$t('components.navigation.sign_up.step_4.foundry_information')}}
            </h3>
            <div :class="[$style.setReviewContainerLeft, $style.setReviewContainerRight]">
              <div :class="[$style.customRow, $style.step2Box]">
                <div :class="$style.divWidth2">
                  <fou-picture :class="[$style.picture]" :id="$vId(this, 'icon')" :src="imageSrc" />
                </div>
                <div :class="$style.imageTextBox">
                  <p class="mt-serif--bold mt-serif--size4 mb-15">
                    {{$t('components.navigation.sign_up.step_4.foundry_heading')}}
                  </p>
                  <p :class="$style.imageTextBoxDesc">
                    {{$t('components.navigation.sign_up.step_4.foundry_description')}}
                  </p>
                </div>
              </div>
              <h3 class="mt-h3" :class="$style.foundryNameWrap">
                <span
                  v-if="isEllipsisActive"
                  class="mt-serif--nowrap"
                  v-tooltip="{content: foundryName, placement: 'bottom'}"
                  >{{foundryName}}</span
                >
                <div v-else class="mt-serif--nowrap" id="foundryNameLabel">
                  <span v-tooltip="{content: foundryName, placement: 'bottom'}">{{foundryName}}</span>
                </div>
                <span class="ml-25" :class="$style.availableSpan">
                  {{$t('components.navigation.sign_up.step_4.available')}}
                </span>
              </h3>
              <p
                class="ql-editor description desc_p_tag"
                v-html="foundryDescription"
                style="margin-top: 0"
              ></p>
            </div>
          </div>
          <!-- Type Designers -->
          <div class="mb-25" v-if="designers.length > 0">
            <h3 class="mt-h3" :class="[$style.newFoundrySection, $style.setReviewContainerLeft]">
              {{$t('components.navigation.sign_up.step_4.type_designers')}}
            </h3>
            <div
              v-if="designers.length > 0"
              v-for="item, key in designers"
              :key="key"
              class="mb-15"
              :class="[$style.setReviewContainerLeft, $style.setReviewContainerRight]"
            >
              <p class="mt-serif--bold mt-serif--size3" :class="[$style.typeDesigners]">
                {{item.firstName}} {{item.lastName}}
                <span :class="[$style.lh30]" class="ml-25 mt-serif--microRegular mt-serif--size6"
                  >{{item.country.name}}</span
                >
              </p>
              <p
                class="ql-editor description desc_p_tag"
                v-html="item.description"
                style="margin-top: 0"
              ></p>
            </div>
          </div>
          <!-- Existing Type Designers -->
          <div class="mb-25" v-if="existingDesigners.length > 0">
            <h3 class="mt-h3" :class="[$style.newFoundrySection, $style.setReviewContainerLeft]">
              {{$t('components.navigation.sign_up.step_4.existing_designers')}}
            </h3>
            <div class="mb-15" :class="[$style.setReviewContainerLeft, $style.setReviewContainerRight]">
              <fou-select-tags
                :id="$vId(this, 'existing-designers-preview')"
                :fou-select="designerValues"
                :removable="false"
              >
              </fou-select-tags>
            </div>
          </div>
        </div>
      </template>
    </fou-container>
    <!-- Buttons todo -->
    <fou-container
      v-if="applicationStatus"
      :id="$vId(this, 'foundry-approve')"
      :class="[$style.mt40]"
      cols="12"
      background
      padded
    >
      <template #header>
        <div :class=$style.headerPrdScore>
        <div class="mt-flex mt-flex--middle">
          <h5 class="mt-h5 mt-serif--bold">{{$t('pages.foundry_application_preview.section_2_header')}}</h5>
        </div>
        <div :class=$style.prdctnScore>
          <div :class="[steps.predictionScore === 'NA' ? $style.notPresent : (
            steps.predictionScore > 0.5.toFixed(3) ? $style.goodPrdScore : (
              steps.predictionScore <= 0.5.toFixed(3) &&  steps.predictionScore > 0.2.toFixed(3) ? $style.avgPrdScore : (
                steps.predictionScore <= 0.2.toFixed(3) ? $style.lowPrdScore : ''
              ))
          )]">
          {{steps.predictionScore ? steps.predictionScore : 'N/A'}}
        </div>
        </div>
      </div>
      </template>

      <template #content>
        <v-grid>
          <v-row class="mt-group mt-group--bottom-large">
            <v-col has="10" off="1">
              <ul class="mt-list" :class="$style.status">
                <li class="mt-list-item" :class="$style.statusItem">
                  <div
                    :id="$vId(this, 'status-approved')"
                    :class="[$style.statusBox, $style.statusBoxApprove, { [$style.statusBoxApproveChecked]: status === 'approved' }]"
                    @click="setStatus('approved')"
                  >
                    <div :class="$style.statusBoxIcon">
                      <review-status-icons
                        :id="$vId(this, 'approved')"
                        status="approved"
                        :list-fill="status === 'approved' ? 'white' : 'grey'"
                        :status-fill="status === 'approved' ? { icon: 'new-blue', bg: 'white' } : null"
                      />
                    </div>
                    <div :class="$style.statusBoxCaption">{{$t('pages.foundry_application_preview.approve')}}</div>
                  </div>
                </li>
                <li class="mt-list-item" :class="$style.statusItem">
                  <div
                    :id="$vId(this, 'rejected')"
                    :class="[$style.statusBox, $style.statusBoxReject, { [$style.statusBoxRejectedChecked]: status === 'rejected' }]"
                    @click="setStatus('rejected')"
                  >
                    <div :class="$style.statusBoxIcon">
                      <review-status-icons
                        :id="$vId(this, 'rejected')"
                        status="rejected"
                        :list-fill="status === 'rejected' ? 'white' : 'grey'"
                        :status-fill="status === 'rejected' ? { icon: 'red', bg: 'white' } : null"
                      />
                    </div>
                    <div :class="$style.statusBoxCaption">{{$t('pages.foundry_application_preview.reject')}}</div>
                  </div>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-grid>
        <v-grid :class="$style.description">
          <v-row>
            <v-col has="10" off="1" :class="$style.noteText">
              <h6 class="mt-h6 mt-serif--bold">{{$t('pages.foundry_application_preview.note')}}</h6>
            </v-col>
          </v-row>
          <v-row>
            <v-col has="10" off="1">
              <section class="mt-section">
                  <TextEditor :id="$vId(this, 'support-note')" v-model="description"
                    name="support_note" :custom=true
                    :editorToolbar="$root.customToolbar" :editorOptions="options"  class="mt-textarea mt-line"
                    :placeholder="$t('pages.foundry_application_preview.type_here')">
                  </TextEditor>
                <div class="mt-line" v-if="errors?.has('support_note')">
                  <p class="mt-error" v-for="error in errors.collect('support_note')">{{error}}</p>
                </div>
              </section>
            </v-col>
          </v-row>
          <v-row>
            <v-col has="10" off="1" :class="$style.supportSubmitButton">
              <div>
                <button type="button" ref="submitBtn" :disabled="disabledBtn" @click="submit()" class="mt-button">
                  {{$t('pages.foundry_application_preview.submit')}}
                </button>
              </div>
            </v-col>
          </v-row>
        </v-grid>
      </template>
    </fou-container>
  </div>
</div>
